import classNames from 'classnames'
import { Button, Modal } from 'ui'

import style from './WarningModal.module.scss'

type ModalConfirmProps = {
  buttonText: string
  modalText?: string
  isModalOpen: boolean
  handlerClick: () => void
  className?: string
}
// предупреждающее окно
export function WarningModal({
  buttonText,
  modalText,
  isModalOpen,
  handlerClick,
  className,
}: ModalConfirmProps) {
  return (
    <Modal open={isModalOpen} onClose={handlerClick}>
      <div className={classNames(style.modal, className)}>
        <span className={style.title}>{modalText}</span>
        <div className={style.btnWrapper}>
          <Button
            onClick={handlerClick}
            variant='contained'
            color='primary'
            className={style.closeBtn}
            data-testid='warning-modal-ok'
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
